module.exports = __webpack_public_path__ + "static/media/dansketext-semibolditalic.ce88254f.eot";